import { useState } from "react"
import { X, Info } from "lucide-react"
import { Button } from "../../ui/button/Button"
import { Alert, AlertDescription } from "../../ui/alerts/Alert"

interface UpcomingReleaseNoticeProps {
  className?: string
  variant: string
}


const variantConfig: Record<string, { title: string; listItems: string[] }> = {
 'scn': {
   title: 'Show Cause Notice',
   listItems: [
     'This feature is currently available in production but not yet deployed to sandbox environments.',
     'Full sandbox availability for Show Cause Notice is scheduled for release within 8-10 working days.',
     'The current demonstration uses representative data to showcase core functionality.',
     'Advanced capabilities will include multiple SCN reports per party involved and support for multiple SCN response uploads per notice served.',
     'Additional enterprise-grade features and integrations will be available upon full release.'
   ]
 },
 'reasoned-order': {
   title: 'Reasoned Order',
   listItems: [
     'This feature is currently available in production but not yet deployed to sandbox environments.',
     'Full sandbox availability for Reasoned Order is scheduled for release within ~15 working days.',
     'The current demonstration uses representative data to showcase core functionality.',
     'Additional enterprise-grade features and integrations will be available upon full release.'
   ]
 },
 'fic-decisions': {
   title: 'FIC Remarks',
   listItems: [
     'This feature is currently available in production but not yet deployed to sandbox environments.',
     'Full sandbox availability for FIC Remarks is scheduled for release within 12-15 working days.',
     'The current demonstration uses representative data to showcase core functionality.',
     'Additional enterprise-grade features and integrations will be available upon full release.'
   ]
 },
 'executive-board-ppt': {
   title: 'Executive Board Presentation',
   listItems: [
     'This feature is currently available in production but not yet deployed to sandbox environments.',
     'Full sandbox availability for Executive Board Presentation is scheduled for release within ~15 working days.',
     'The current demonstration uses representative data to showcase core functionality.',
     'Additional enterprise-grade features and integrations will be available upon full release.'
   ]
 }
}


export function UpcomingReleaseNotice({ className, variant }: UpcomingReleaseNoticeProps) {
  const config = variantConfig[variant]

  return (
    <div className={`mb-6 ${className}`}>
      <Alert className="border-blue-200 bg-blue-50 text-blue-700 rounded-lg">
        <div className="px-6 py-4">
          <div className="flex items-start gap-3">

            <AlertDescription className="flex-1">
              <div className="flex items-center justify-between w-full">
                <div className="flex-1 flex flex-col">
                  <div className="flex items-center gap-2">
                    <span className="font-bold">Upcoming Feature Release Notification</span>
                    
                  </div>
                </div>
              </div>

              
                <div className="mt-3 text-xs font-medium space-y-2">
                  <p>This feature represents a mock pre-release version designed to demonstrate functionality that is currently available in our production environment. Please note the following:</p>
            `       <ul className="list-disc list-inside space-y-1 ml-2 text-blue-700">
                        {config.listItems.map((item, index) => (
                            <li key={index}>{item}</li>
                        ))}
                        </ul>
                    <br />
                  <p>For further clarifications or any custom requests, please contact our team.</p>
                </div>

            </AlertDescription>
          </div>
        </div>
      </Alert>
    </div>
  )
}